'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');
}



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/react/index.js
// module id = ../../node_modules/react/index.js
// module chunks = 18